export const APP_ID = 628095415;
export const TESTNET_APP_ID = 75101786;

export const REGISTRATION_PRICE = {
  CHAR_3_AMOUNT: 150000000,
  CHAR_4_AMOUNT: 50000000,
  CHAR_5_AMOUNT: 5000000,
};

export const TRANSFER_FEE = 2000000;

export const IPFS_LINK = "https://ipfs.infura.io/ipfs/";

export const ASCII_CODES = {
  ASCII_A: 97,
  ASCII_Z: 122,
  ASCII_0: 48,
  ASCII_9: 57,
};

export const ALLOWED_SOCIALS = [
  "github",
  "twitter",
  "telegram",
  "youtube",
  "reddit",
  "discord",
];

export const TESTNET_ESCROW =
  "ACFFHRILZQ6W2UDNYYTHV55YS6MZWJR4PEDVBFAL575FFK4AT4UBCO3SXE";
export const MAINNET_ESCROW =
  "SYGCDTWGBXKV4ZL5YAWSYAVOUC25U2XDB6SMQHLRCTYVF566TQZ3EOABH4";

export const ALLOWED_TLDS = ["algo"];
